export default __webpack_public_path__ + "e2d119b8382a92f87749eabbc07d9400.svg";